
interface IControl {
  id:     number;
  titulo: string;
  desc:   string;
}

const control : IControl[] = [
  {
    id: 1,
    titulo: "Control",
    desc: "Por favor completa el control para estar al tanto de tu progreso 💪.",
  },
  {
    id: 2,
    titulo: "¡Estamos en esto juntos!",
    desc: "Actualízanos cómo te ha ido, para diseñar tu próximo mes.",
  },
  {
    id: 3,
    titulo: "Avanzemos al siguiente nivel",
    desc: "Vamos a ver cómo estás y podamos mejorar a partir de ahí",
  },
  {
    id: 4,
    titulo: "¡Aquí para ayudarte!",
    desc: "Comparte tu progreso para que sigamos trabajando en tus metas",
  },
  {
    id: 5,
    titulo: "¡Felicitaciones por tu constancia!",
    desc: "Actualízanos cómo te fue, y diseñemos el siguiente paso hacia tu objetivo",
  },
  {
    id: 6,
    titulo: "Nuevo mes. Nueva oportunidad",
    desc: "Queremos saber como te ha ido para diseñar tu próximo plan",
  },
  {
    id: 7,
    titulo: "¡Eso! Seguimos avanzando",
    desc: "Comparte tus avances y podrás desbloquear el siguiente paso",
  }
]


export default control;